<template>
  <div>
    <QExpansionItem
      expand-separator
      :label="labelEntityCashFlow"
      :header-style="{
        color: 'var(--primary-color)',
        fontWeight: 500,
        paddingLeft: '0px',
        borderBottom: '1px solid #ccc8c8',
        marginBottom: '20px'
      }"
      :disable="disableCollapse"
      v-model="openEntityCashFlow"
    >
      <QForm @submit.prevent="onSubmitEntityCashFlow">
        <div class="row">
          <InputFieldWithPrefix label="Annual Revenue" v-model="entityDetails.annualRevenue" :required="true" type="number" />
        </div>
        <div class="q-pt-lg q-pb-sm text-center">
          <QBtn color="primary" no-caps type="submit" label="Next" :disable="!disableNext" :loading="loading" />
        </div>
      </QForm>
    </QExpansionItem>
  </div>
</template>

<script>
import { QBtn, QForm, QSelect, QExpansionItem } from 'quasar';
import { mapState, mapActions } from 'vuex';
import InputFieldWithPrefix from '@/components/Atoms/InputFieldWithPrefix.vue';
import MutateCreateOrUpdateProperty from '@/graphql/mutations/MutateCreateOrUpdateProperty';
import { GLOBAL_ERROR } from '@/components/GlobalError/GlobalError';

export default {
  name: 'CalculatorEntityCashflow',
  components: { InputFieldWithPrefix, QForm, QBtn, QExpansionItem },
  props: ['disableCollapse', 'openCollapse'],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    isCompleted() {
      if (this.scoreboard && this.scoreboard.businessDetails && this.scoreboard.businessDetails.annualRevenue) return true;
      else return false;
    },
    labelEntityCashFlow() {
      return 'Business Cashflow Details' + (this.isCompleted ? '' : '');
    },
    disableNext() {
      if (this.entityDetails.annualRevenue) return true;
      else return false;
    }
  },
  created() {
    if (this.scoreboard && this.scoreboard.businessDetails && this.scoreboard.businessDetails.annualRevenue) {
      this.entityDetails.annualRevenue = this.scoreboard.businessDetails.annualRevenue;
      setTimeout(() => {
        this.$emit('entityCashFlowCompleted');
      });
    }
  },
  data: function () {
    return {
      entityDetails: {
        annualRevenue: ''
      },
      openEntityCashFlow: false,
      loading: false
    };
  },
  mounted() {
    this.openEntityCashFlow = this.openCollapse;
  },
  watch: {
    openCollapse: function (newValue) {
      this.openEntityCashFlow = newValue;
    }
  },
  methods: {
    ...mapActions({
      updateVehicleApplicationState: 'vehicleApplication/updateVehicleApplicationState'
    }),
    onSubmitEntityCashFlow: async function () {
      this.loading = true;
      await this.$apollo
        .mutate({
          mutation: MutateCreateOrUpdateProperty,
          variables: {
            applicationId: this.$store.getters['vehicleApplication/vehicleApplication']
              ? this.$store.getters['vehicleApplication/vehicleApplication'].applicationId
              : null,
            params: {
              value: this.entityDetails.annualRevenue,
              propertyFirst: 'businessDetails',
              propertySecond: 'annualRevenue'
            }
          }
        })
        .then((data) => {
          this.updateVehicleApplicationState({
            value: this.entityDetails.annualRevenue,
            propertyFirst: 'businessDetails',
            propertySecond: 'annualRevenue'
          });
          setTimeout(() => {
            this.$emit('entityCashFlowCompleted', true);
          });
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loading = false;
    }
  }
};
</script>
